import React from 'react'
import FormCatégorie from '../../Components/FormCatégorie'

const AjouterCatégorie = () => {
  return <FormCatégorie />
}

export default AjouterCatégorie
